import $ from 'jquery';
//productComposition-v1__container
const productCompositionV1Semantics = {
    mainWrapClass: 'product-composition-v1',
    isInitializedAttribute: 'data-is-initialized',
    instanceIdAttribute: 'data-instance-id',
    imageContainer: 'layers__image',
    elementActiveClassName: '_active',
    elementDisabledClassName: '_disabled',
    dataLayerIdAttribute: 'data-layer-id',
    layerLabelClass: 'layers__settings'
}

$(function () {
    let roots = $(`.${productCompositionV1Semantics.mainWrapClass}`);
    if (roots.length === 0) {
        return false;
    }
    let productCompositionV1 = new ProductCompositionV1();
    /**
     * Checking other instances
     */
    roots.each((index, el) => {
        let isInitialized =
            ($(el).attr(`${productCompositionV1Semantics.isInitializedAttribute}`) === 'true');

        if (!isInitialized) {
            productCompositionV1.registerInstance($(el));
            productCompositionV1.registerListeners($(el));
        }
    });
})

class ProductCompositionV1 {

    constructor() {
        this.pluginInstances = {};
    }

    registerInstance(el) {
        let instanceId =
            el.attr(`${productCompositionV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        try {
            let object = el.find(`.${productCompositionV1Semantics.mainWrapClass}`);
            el.attr(`${productCompositionV1Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        let elements = $(`.${productCompositionV1Semantics.mainWrapClass}[${
            productCompositionV1Semantics
                .instanceIdAttribute
        }="${
            el.attr(productCompositionV1Semantics
                .instanceIdAttribute)
        }"]`);
        let self = this;
        // наведение на лейблы слоев (номера в кружочках)
        elements.on(
            'mouseenter',
            `.${productCompositionV1Semantics.layerLabelClass}`,
            function (e) {
                e.preventDefault();
                let current = $(e.currentTarget);
                let dataId = current.attr(productCompositionV1Semantics.dataLayerIdAttribute);
                let layerItem = elements.find(`.${productCompositionV1Semantics.imageContainer}[${productCompositionV1Semantics.dataLayerIdAttribute}="${dataId}"]`)
                current.addClass(productCompositionV1Semantics.elementActiveClassName)
                    .siblings()
                    .removeClass(productCompositionV1Semantics.elementActiveClassName);
                self.addSelectedClass(layerItem);
            }
        );

         elements.on(
            'mouseleave',
            `.${productCompositionV1Semantics.layerLabelClass}`,
            function (e) {
                e.preventDefault();
                let current = $(e.currentTarget);
                let dataId = current.attr(productCompositionV1Semantics.dataLayerIdAttribute);
                let layerItem = elements.find(`.${productCompositionV1Semantics.imageContainer}[${productCompositionV1Semantics.dataLayerIdAttribute}="${dataId}"]`)
                current.removeClass(productCompositionV1Semantics.elementActiveClassName);
                layerItem.removeClass(productCompositionV1Semantics.elementActiveClassName);
            }
        );

        // наведение мышки на слои
        elements.on(
            'mouseenter',
            `.${productCompositionV1Semantics.imageContainer}`,
            function (e) {
                e.preventDefault();
                let current = $(e.currentTarget);

                self.addSelectedClass(current);

                let dataId = current.attr(productCompositionV1Semantics.dataLayerIdAttribute);

                elements.find(`.${productCompositionV1Semantics.layerLabelClass}[${productCompositionV1Semantics.dataLayerIdAttribute}="${dataId}"]`)
                    .addClass(productCompositionV1Semantics.elementActiveClassName)
                    .siblings()
                    .removeClass(productCompositionV1Semantics.elementActiveClassName);
            });

        elements.on(
            'mouseleave',
            `.${productCompositionV1Semantics.imageContainer}`,
            function (e) {
                e.preventDefault();
                let current = $(e.currentTarget);
                current.removeClass(productCompositionV1Semantics.elementActiveClassName)
                    .siblings()
                    .removeClass(productCompositionV1Semantics.elementDisabledClassName)

                elements.find(`.${productCompositionV1Semantics.layerLabelClass}`)
                    .removeClass(productCompositionV1Semantics.elementActiveClassName);
            });
    }

    addSelectedClass(element) {
        element.addClass(productCompositionV1Semantics.elementActiveClassName)
            .removeClass(productCompositionV1Semantics.elementDisabledClassName)
            .siblings()
            .addClass(productCompositionV1Semantics.elementDisabledClassName)
    }
}

export default ProductCompositionV1;